export default __webpack_public_path__ + "static/media/award1.04a40305.jpeg";